export const environment = {
  production: true,
  appKey: 'Basic OUFASSRTUjYhUCQwI0lANT9TQDg/SDo=',

  deviceType: 'web',
  x_api_key: 'qPTxs8bAfX3bETrs5QpWtv5rEmlEgEZ8PfkowFw0',
  hashKey: '@lb3rt!Th0m@52310n3$r!n!v@s@R@m@nuj@n',
  immunityKey: 'D0ct0r0p3r@t!0nC3nt3rQu35t!0nUNity',
  device_info: '',
  googleMasApi: 'AIzaSyCGeVp0fBSjWUqRN6GHE-MGXvcjvrJeSXM',
  jwtSecretKey: 'zkbzRk11dSbaQjGTDRcw8yhInNFIyl6MHLZOISPwWy2DR5kqGuuaXvzU6qxCUUjIp1WBWNcGn6zsXy7kiptLsENH5cVOyRpFTOgG',
  api_debugger: 0,          // 0 for off and 1 for on
  is_encoded_response: 0,
  session_id_reset_time: 1200000, // 20 min
  ideal_state: {
    ideal_state_time: 120000,
    ideal_state_timer: 0,
    is_ideal_state: false,
    current_page: '',
    user_inactive_time: 600000, // 10 min
    user_inactive_timer: 0
  },
  recall_live_webinar_comment_list_time: 240, // in seconds (4 min)
  event_tracking: 1,
  is_check_beta_ver: 0,
  credentials: {
    appId: '52212',
    authKey: 'V-jLcBzARm4UpZO',
    authSecret: 'NPnGG4HS4agamKc'
  },

  survey_base_href: 'sarvekshan',
  hCaptchaSitekey: '04ce8b60-9897-415b-83a9-787bcee82003',
  clevertapConfigKey: 'W65-RWW-R45Z',
  branchIOKey : 'key_live_mkz2uZGAGwto1ql1SRv3xgkgrygnyc9d',
  tncUrl: 'https://docquity.com/termsandconditions/',
  privacyPolicyUrl: 'https://docquity.com/privacypolicy/',

  pif: 'BR68MR0Vpel-51325',
  pffCode: 'BR2IplRax3A-51326',

  local_nav: [
    { id: 1, url: '/web', value: 'gr', module_name: 'Web Trends', menu_icon: 'icon-home' },
    { id: 2, url: '/cme', value: 'cme', module_name: 'Cme', menu_icon: 'icon-cpd' },
    { id: 8, url: '/clinical', value: 'journal', module_name: 'clinical', menu_icon: 'icon-cme' },
    { id: 9, url: '/channel/list', value: 'channel', module_name: 'Channel', menu_icon: 'icon-channel' },
    { id: 4, url: '/refer-and-earn/referal', value: 'rewards', module_name: 'refer-and-earn', menu_icon: 'icon-channel3' },
    { id: 29, url: '/connection/suggestion', value: 'connection', module_name: 'connection', menu_icon: 'icon-connection' },
    { id: 24, url: '/doctalk', value: 'doctalk', module_name: 'doctalk', menu_icon: 'icon-docktalks' },
    { id: 25, url: '/survey', value: 'survey', module_name: 'survey', menu_icon: 'icon-survey' },
    { id: 31, url: '/webinar/list', value: 'webinar', module_name: 'webinar', menu_icon: 'icon-webinar' }
  ],
  baseUrls: {
    apiUrl: 'https://api.docquity.com/',
    oldApiUrl: 'https://docquity.com/',
    journalApiUrl: 'https://journals.docquity.com/',
    sqsQueueURL: 'https://sqs.ap-southeast-1.amazonaws.com/706465660047/VideoWatchLog-prod',
    webUrl: 'https://app.docquity.com/',
    web_socket_url: 'https://socket-v1.docquity.com/',
    CHATBOT_SOCKET_URL: 'https://socket-v1.docquity.com/',
    live_comment_url: 'https://socketapi2.docquity.com/',
    MEETING_GROUP_CHAT_URL: 'https://socket-v1.docquity.com/',
    webSiteUrl: 'https://app.docquity.com',
    JOIN_MEETING_URL: 'https://connect.docquity.com',
    encryp_api_url: 'https://api.docquity.com/validate/api-extraction',
    quickBlox: 'https://api.quickblox.com',
    sts_data_url: ' https://dkl3fzjis7.execute-api.ap-southeast-1.amazonaws.com/prod',
    main_website_url: 'https://docquity.com',
    WHATS_MY_IP: 'https://docquity.com/detect/whatsmyip.php',
    nodeApiUrl: 'https://socket-v1.docquity.com/',
    nestApiUrl: 'https://napi.docquity.com/',
    externalSurveyResourceUrl: 'https://www.docquity.com/resources',
    baseUrl2_0: 'https://dus.dev.docquity.com/',
    dxUrl: 'https://app.joindx.ai/'
  },
  APP_CONFIG_URL: 'https://id.docquity.com/api/v2/config/app',
  API_URLS: {
    'calendar': 'https://api.docquity.com',
    'amazon': 'https://dkl3fzjis7.execute-api.ap-southeast-1.amazonaws.com/prod/docquityststoken',
    'privacy_policy': 'https://docquity.com/privacypolicy',
    'terms_and_condition': 'https://docquity.com/termsandconditions',
    'analytics': 'https://apilytics.docquity.com',
    'chat_credentials': 'https://docquity.com',
    'auto_verification': 'https://api.docquity.com',
    'onboarding': 'https://api.docquity.com',
    'quickblox': 'https://docquity.com',
    'voip_node': 'https://api.docquity.com',
    'comment': 'https://api.docquity.com',
    'bookmark': 'https://api.docquity.com',
    'event': 'https://api.docquity.com',
    'voip': 'https://api2.docquity.com',
    'search': 'https://api.docquity.com',
    'community': 'https://napi.docquity.com',
    'ncp': 'https://api.docquity.com',
    'card_rendering_analytics': 'https://napi.docquity.com',
    'editor': 'https://api.docquity.com',
    'user': 'https://api.docquity.com',
    'clinic_consent': 'https://api.docquity.com',
    'chat_bot': 'https://socket-v1.docquity.com',
    'mr': 'https://socket-v1.docquity.com',
    'webinar': 'https://api.docquity.com',
    'payment': 'https://api.docquity.com',
    'nudge': 'https://api.docquity.com',
    'background': 'https://api.docquity.com',
    'report_user': 'https://api.docquity.com',
    'referral': 'https://api.docquity.com',
    'notification': 'https://api.docquity.com',
    'gr': 'https://api.docquity.com',
    'verification': 'https://api.docquity.com',
    'others': 'https://api.docquity.com',
    'pharma': 'https://api.docquity.com',
    'edetailing': 'https://api.docquity.com',
    'survey': 'https://api.docquity.com',
    'profile': 'https://api.docquity.com',
    'journal': 'https://api.docquity.com',
    'feedback': 'https://api.docquity.com',
    'socket': 'https://socket-v1.docquity.com',
    'doctalks': 'https://api.docquity.com',
    'cme': 'https://api.docquity.com',
    'like': 'https://api.docquity.com',
    'feed': 'https://api.docquity.com',
    'socket_comment': 'https://socket-v1.docquity.com',
    'speciality': 'https://api.docquity.com',
    'chat': 'https://api.docquity.com',
    'registration': 'https://api.docquity.com',
    'media_upload': 'https://docquity.com',
    'meta_data': 'https://docquity.com',
    'forward_flow': 'https://napi.docquity.com',
    'join_meeting_web': 'https://connect.docquity.com',
    'ip_address_api': 'https://docquity.com',
    'mr_connect_mobile': 'https://mrconnectapi.docquity.com',
    'mr_connect': 'https://api.docquity.com',
    'magistrate': 'https://id.docquity.com',
    'pvs': 'https://napi.docquity.com',
    'keeper': 'https://id.docquity.com',
    'dfs': 'https://id.docquity.com',
    'record_browser_details': 'https://api.docquity.com',
    'survey_webview': 'https://app.docquity.com/#/survey/list',
    'user_stories': 'https://id.docquity.com',
    'openContent': 'https://napi.docquity.com',
  },
  versions: {
    api_url_version: '4.1',
    api_url_version_updated: '4.3',
    api_version_47: '4.7',
    api_version: '4.0',
    api_version_updated: '4.3',
    webinar_api_version: '4.2',
    GROUP_CHAT_VERSION: '1',
    releaseVersion: 'V 4.0',
    GR_RELEASE_VERSION: '16',
    RELEASE_VERSION_17: '17',
    RELEASE_VERSION_18: '18',
    RELEASE_VERSION_20: '20',
    RELEASE_VERSION_19: '19',
    updatedReleaseVersion: '12',
    appReleaseVersion: '11',
    appVersion: '1110',
    apiVersion21: '2.1',
    apiVersion3: '3',
    apiVer28: '2.8',
    apiVer1: '1',
    apiVer27: '2.7',
    apiVer23: '2.3',
    apiVer41: '4.1',
    apiVer22: '2.2',
    apiVer25: '2.5',
    apiVer44: '4.4',
    apiVer45: '4.5',
    releaseVersion9: '9',
    apiVersion20: '2.0',
    apiVer46: '4.6',
    apiVer49: '4.9',
    apiVer50: '5.0',
    apiVer51: '5.1',
    apiVer52: '5.2',
    apiVer53: '5.3',
    apiVer70: '7.0',
    apiVer71: '7.1',
    apiVer72: '7.2',
  },
  udid: '123',
  accessTokenRenewIntervalPercentage: 20,
  keeperPublicId: 'ABCD4567EG',
  firebase: {
    apiKey: 'AIzaSyCu5PPCVGosNUp2JRumB-ZGaYbxTlxgSjI',
    authDomain: 'docquity-1269.firebaseapp.com',
    databaseURL: 'https://docquity-1269.firebaseio.com',
    projectId: 'docquity-1269',
    storageBucket: 'docquity-1269.appspot.com',
    messagingSenderId: '874968311035',
    appId: '1:874968311035:web:536a015c1da0217df33c5e',
    measurementId: 'G-K5FGCSZYBQ',
    vapidKey: 'BFSVBXFBkiuvrbbR08NEdkqf1g21cJBZ1VixW299yfnUc0UHhXLDm6q5LmpZISu_zxGcaNaT_kZX1BsOu1O7dpU'
  },
  publicAnalyticMaxRecordCount: 1,
  isXhr: false,
  azFeatureOnOffData: 'https://docquity-bucket-dev.s3.ap-southeast-1.amazonaws.com/web-app/dq-az-feature-on-off.json',
  enableRedeemSurveyForCountryCodes : ['91','62'],
  stopRedirectionForExternalSurveyCodes: ['BRDX1qNyJjx-52538']
};

